module.exports = __webpack_public_path__ + "img/maynilad_logo@2x.6638f564.png";